export const environment = {
  production: false,
  /** Prefer live Freeform APIs so generated RDS test data is visible. */
  useFreeformDummyData: false,
  /** Show Seed E2E data panel (transcript → RDS). Dev builds only — never enable in prod. */
  showFreeformE2ESeed: true,
  COGNITO_HOST_URL: process.env['COGNITO_HOST_URL'],
  COGNITO_CLIENT_ID: process.env['COGNITO_CLIENT_ID'],
  COGNITO_REDIRECT_URL: process.env['COGNITO_REDIRECT_URL'],
  NOVA_APPLICATION_ID: process.env['NOVA_APPLICATION_ID'],
  NOVA_BASE_URL: process.env['NOVA_BASE_URL']
};
